export const PRODUCT_DETAILS_REQUEST = 'PRODUCT_DETAILS/REQUEST';
export const PRODUCT_DETAILS_SUCCESS = 'PRODUCT_DETAILS/SUCCESS';
export const PRODUCT_DETAILS_FAILURE = 'PRODUCT_DETAILS/FAILURE';
export const CHANGE_SELECTED_PART_NUMBER = 'CHANGE_SELECTED_PART_NUMBER';
export const RESET_STATE = 'RESET_STATE';
export const RESET_PDP_STATE = 'RESET_PDP_STATE';
export const PROMO_PRICE_REQUEST = 'PROMO_PRICE/REQUEST';
export const PROMO_PRICE_SUCCESS = 'PROMO_PRICE/SUCCESS';
export const PROMO_PRICE_FAILURE = 'PROMO_PRICE/FAILURE';
export const DELIVERY_RETURNS_CONTENT_SUCCESS = 'DELIVERY_RETURNS_CONTENT/SUCCESS';
